export default "__VITE_ASSET__BpQi_7zm__"